// get all last changed for history

import services from '.'
import ldb from '../base/lib/ldb'
import emitter from '../base/utils/emitter'
import { IHistoryItem } from '../interfaces/history'

// get all last changed for history
async function work() {
    console.log('syncing...')

    try {
        if (!ldb.get('ai-art-user')) return
        const isValidate = await services.auth.validateToken()
        if (!isValidate) {
            ldb.remove('ai-art-user')
            return
        }
        const lastChanged = ldb.get('last-changed') || '1970-01-01T00:00:00.000Z'

        const remoteHistory = await services.history.get(lastChanged)
        console.log('synced writing last-ch----');

        for (const item of remoteHistory) {
            const possibleLocal = await services.db.byId('history', item.id) as IHistoryItem
            if (!possibleLocal) {
                await services.history.save({ ...item, synced: 1 })
            } else {
                if (possibleLocal.last_changed <= item.last_changed) {
                    await services.history.update({ ...item, synced: 1 })
                } else {
                    await services.history.push(possibleLocal)
                }
            }
        }
        
        const unsyncdHistory = await services.db.find('history', { index: 'synced', value: 0 })
        for (const item of unsyncdHistory) {
            await services.history.push(item)
        }

        emitter.emit('synced')
        console.log('synced writing last-changed');
        
        ldb.set('last-changed', new Date().toISOString())
    } catch (error) {
        console.log(error)

    }
}

export default {
    work
}